import React from 'react';
import {Menu, MenuButton, MenuItem, MenuItems, Transition} from "@headlessui/react";
import {FaChevronDown} from "react-icons/fa";

const ToolbarDropdownItem = ({item, selected, onChange}) => {
    const isActive = item === selected;

    return (
        <MenuItem>
            <button className={"image-editor-button" + (isActive ? " active" : "")} onClick={() => onChange(item)}>
                {item}
            </button>
        </MenuItem>
    )
}

const ToolbarDropdownBtn = ({children, title, values, id, selected, onChange, disabled}) => {
    return (
        <Menu>
            <MenuButton className="image-editor-button" title={title} disabled={disabled}>
                {children}
                <FaChevronDown className="image-editor-button-dropdown-small" />
            </MenuButton>
            <Transition
                enter="transition ease-out duration-75"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
            >
                <MenuItems anchor="bottom" className="heading-dropdown">
                    {
                        values.map((item, i) => <ToolbarDropdownItem item={item} key={id + "-" + i} selected={selected} onChange={onChange}/>)
                    }
                </MenuItems>
            </Transition>
        </Menu>
    );
};

export default ToolbarDropdownBtn;